export default {
   fetchData: true,
   fetchFilterData: false,
   reports: null,
   fetchGhostData: true,
   ghost: [],
   fetchStepsData: true,
   steps: [],
};
